import React, { useEffect, useRef, useState } from "react";
import { Button, ConfigProvider } from "antd";
import { useSelector } from "react-redux";

const COUNTDOWN_SECONDS = 5;

const RetryProgressButton = ({
    duration = COUNTDOWN_SECONDS,
    onComplete,
    onStop,
    text = "Retrying • Click to Stop",
    backgroundColor = "rgba(24, 144, 255, 1)",
    fontSize = "16px",
    fontWeight = 400,
    padding = "14px 0px",
    lineHeight = "20px",
    fontFamily = "Poppins",
    block = false,
}) => {
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);
    const startTimeRef = useRef(null);

    const theme = useSelector(
        (state) =>
            state?.paymentSessionDetails?.sessionDetails?.merchantDetails
                ?.checkoutTheme
    );

    // Same color resolution as CustomButton
    const primaryColor = theme?.primaryButtonColor || backgroundColor;
    const textColor = theme?.primaryTextColor || "#ffffff";
    const resolvedFont = theme?.font || fontFamily;
    const resolvedRadius = theme?.buttonShape === "RECTANGLE" ? "0px" : "6px";

    useEffect(() => {
        startTimeRef.current = performance.now();

        intervalRef.current = setInterval(() => {
            const elapsed = performance.now() - startTimeRef.current;
            const pct = Math.min((elapsed / (duration * 1000)) * 100, 100);
            setProgress(pct);

            if (pct >= 100) {
                clearInterval(intervalRef.current);
                onComplete?.();
            }
        }, 50);

        return () => clearInterval(intervalRef.current);
    }, []);

    const handleClick = () => {
        clearInterval(intervalRef.current);
        setProgress(0);
        onStop?.();
    };

    return (
        <ConfigProvider
            wave={{ disabled: true }}
            theme={{
                token: {
                    colorPrimary: primaryColor,
                    borderRadius: theme?.buttonShape === "RECTANGLE" ? 0 : 6,
                    boxShadow: "0 1px 0 rgba(1, 2, 2, 0.1)",
                },
            }}
        >
            <Button
                block={block}
                type="primary"
                onClick={handleClick}
                style={{
                    padding,
                    fontWeight,
                    fontSize,
                    lineHeight,
                    fontFamily: resolvedFont,
                    color: textColor,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* Progress fill overlay */}
                <span
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: `${progress}%`,
                        backgroundColor: "rgba(0, 0, 0, 0.2)", // dark tint over primaryColor
                        borderRadius: resolvedRadius,
                        transition: "width 0.05s linear",
                        pointerEvents: "none",
                        zIndex: 0,
                    }}
                />
                {/* Label */}
                <span style={{ position: "relative", zIndex: 1 }}>
                    {text}
                </span>
            </Button>
        </ConfigProvider>
    );
};

export default RetryProgressButton;